export class Adres {

  constructor(
    private straat: string,
    private nummer: string,
    private bus: string,
    private postcode: string,
    private gemeente: string,
  ) {
  }

  static deserialize(dto: AdresDto): Adres {
    return new Adres(
      dto.straat,
      dto.nummer,
      dto.bus,
      dto.postcode,
      dto.gemeente
    );
  }

  getStraat(): string {
    return this.straat;
  }

  getNummer(): string {
    return this.nummer;
  }

  getBus(): string {
    return this.bus;
  }

  getPostcode(): string {
    return this.postcode;
  }

  getGemeente(): string {
    return this.gemeente;
  }
}

export interface AdresDto {
  straat: string;
  nummer: string;
  bus: string;
  postcode: string;
  gemeente: string;
}
